import * as Sentry from "@sentry/browser";
import Fuse, { FuseOptions } from "fuse.js";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { Venue } from "sweet-global";
import * as selectors from "sweet-web/redux/selectors";
import { RootState } from "../index";
import {
  Filters,
  RESET_SEARCH,
  SEARCH_FAILURE,
  SEARCH_FILTER,
  SEARCH_FOCUS,
  SEARCH_INIT,
  SEARCH_SUCCESS,
  SearchActionTypes
} from "./types";

export const resetSearch = (): SearchActionTypes => {
  return { type: RESET_SEARCH };
};

export const searchFocus = (focus: boolean): SearchActionTypes => {
  return { type: SEARCH_FOCUS, focus };
};

export const searchFilter = (filter: Partial<Filters>): SearchActionTypes => {
  return { type: SEARCH_FILTER, filter };
};

export const searchInit = (query: string): SearchActionTypes => {
  return { type: SEARCH_INIT, query };
};

export const searchSuccess = (results: Venue[]): SearchActionTypes => {
  return { type: SEARCH_SUCCESS, results };
};

export const searchFailure = (error: Error): SearchActionTypes => {
  return { type: SEARCH_FAILURE, error };
};

export const Search = (
  query: string
): ThunkAction<Promise<void>, RootState, null, Action<string>> => async (
  dispatch,
  getState
) => {
  try {
    dispatch(searchInit(query));

    const state = getState();
    const userType = selectors.userType(state);
    const venues =
      userType === "ADMIN"
        ? selectors.myVenues(state)
        : selectors.venues(state);

    const venueList = Object.keys(venues).map(venueId => ({
      id: venueId,
      ...venues[venueId]
    }));

    const options: FuseOptions<Venue> = {
      keys: ["name", "location.city"],
      shouldSort: true,
      threshold: 0.6,
      maxPatternLength: 32,
      minMatchCharLength: 1
    };

    if (query) {
      const fuse = new Fuse(venueList, options);
      const results = fuse.search(query) as Venue[];
      dispatch(searchSuccess(results));
    } else {
      dispatch(searchSuccess(venueList));
    }
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
    dispatch(searchFailure(error));
  }
};
